import { render, staticRenderFns } from "./InventoryAddProductModal.vue?vue&type=template&id=327da980&scoped=true&"
import script from "./InventoryAddProductModal.vue?vue&type=script&lang=js&"
export * from "./InventoryAddProductModal.vue?vue&type=script&lang=js&"
import style0 from "./InventoryAddProductModal.vue?vue&type=style&index=0&id=327da980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327da980",
  null
  
)

export default component.exports